// Un solo formulario de cotización para todo el sitio. Cualquier botón lo abre con
// useContactForm().open({ intent, product, industry, email }) y el formulario llega
// con esos datos ya puestos.
import React, { createContext, useCallback, useContext, useState } from "react";
import { ContactModal } from "./ContactModal";

const ContactContext = createContext({ open: () => {} });

export const ContactProvider = ({ children }) => {
  const [prefill, setPrefill] = useState(null);
  const open = useCallback((data = {}) => setPrefill({ intent: "contact", ...data }), []);
  const close = useCallback(() => setPrefill(null), []);

  return (
    <ContactContext.Provider value={{ open }}>
      {children}
      <ContactModal prefill={prefill} onClose={close} />
    </ContactContext.Provider>
  );
};

export const useContactForm = () => useContext(ContactContext);
